<app-orgs-view [allOrganizationData]="allOrganizationData$ | async"></app-orgs-view>
